import React, { useState, useEffect } from 'react';
import DragAndDropImage from '../../../../../../components/ImageUpload/imageUpload';

const PictureComponent = ({ mediaData, handleCreateMedia, handleMediaDelete }) => {
  const [uploadedImages, setUploadedImages] = useState([]);

  useEffect(() => {
    setUploadedImages(mediaData || []);
  }, [mediaData]);

  const handleImagesUpdate = (images) => {
    setUploadedImages(images);
    handleCreateMedia(images);
  };

  return (
    <div className="p-4 border border-lightPrimary/40 dark:border-info/40 mt-6 dark:bg-custom-radial bg-white">
      <h3 className="text-lg font-semibold mt-6 text-lightPrimary dark:text-primary-gradient">Uploaded Images:</h3>
      <DragAndDropImage
        onImagesUpdate={handleImagesUpdate}
        handleMediaDelete={handleMediaDelete}
        uploadedImages={uploadedImages}
        accept=".png,.jpg,.jpeg,.webp,.gif"
        showPic={3}
      />
    </div>
  );
};

export default PictureComponent;
